import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import './Beranda.css';
import bgBeranda from '../teagarden_road.png'; 

const Beranda = () => {
  const navigate = useNavigate();

  return (
    <div className="beranda-wrapper">
      <Navbar />
      <div className="beranda-main">
        {/* Pindahkan background image ke inline style hero-box */}
        <div className="hero-box" style={{ backgroundImage: `url(${bgBeranda})` }}>
          <div className="hero-content">
            <h3 className="hero-subtitle">Hello, Neglawangi!</h3>
            <h1 className="hero-title">Selamat Datang di Website Agrid</h1>
            <p className="hero-text">
              Agrid merupakan inovasi alat berupa akuaponik yang dapat
              dipantau melalui website berikut.
            </p>
            <button className="btn-mulai" onClick={() => navigate('/dashboard')}>
              Mulai
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Beranda;